import { useTranslation } from 'react-i18next';
import React from 'react';
import { Link } from 'react-router-dom';
export const asset = name => require(`../assets/${name}`);
export const shop = 'https://s.shopee.co.id/609CJ7KVyU?share_channel_code=1';
export const officialLinks = 'https://heylink.me/NaktarasoOfficial';
export const whatsapp = 'https://wa.me/6281275740024';
export function Arrow() {
  return <span aria-hidden="true">↗</span>;
}
export function External({
  href,
  children,
  className = ''
}) {
  const {
    t
  } = useTranslation();
  return <a href={href} className={className} target="_blank" rel="noopener noreferrer">{children}<span className="sr-only"> {t("opens_in_a_new_tab")}</span></a>;
}
export function PageHeading({
  eyebrow,
  title,
  children
}) {
  return <header className="page-heading"><span className="eyebrow">{eyebrow}</span><h1>{title}</h1>{children && <p>{children}</p>}</header>;
}
export function Invitation() {
  const {
    t
  } = useTranslation();
  return <section className="invitation wrap"><div><span className="eyebrow">{t("from_west_sumatra_for_you")}</span><h2>{t("a_taste_of_home")}<br />{t("wherever_you_are")}</h2></div><Link className="button dark" to="/catalogue">{t("find_your_rendang")} <Arrow /></Link></section>;
}
